import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './BtnGreen32.module.scss';

const BtnGreen32 = ({
  textButton,
  onClick,
  className,
  type = 'button',
  disabled = false
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={cn(classes.btnGreen32, className)}
      disabled={disabled}
    >
      <p>{textButton}</p>
    </button>
  );
};

BtnGreen32.propTypes = {
  textButton: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.string,
  disabled: PropTypes.bool
};

export default BtnGreen32;
